var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "deliverable-listing social-media",
      class: {
        hasFilter:
          _vm.filterQuery.status.length ||
          _vm.filterQuery.coordinator.length ||
          _vm.filterQuery.tag.length ||
          _vm.filterQuery.outlet.length
      }
    },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModal",
            title: "Edit Social Deliverable"
          },
          on: {
            hide: _vm.editSocialModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditSocialModal",
            attrs: {
              allContacts: _vm.allContacts,
              namespace: _vm.namespace,
              tabIndex: _vm.tabIndex
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "deleteDeliverableConfirmModal",
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: _vm.onConfirmRemoveDeliverable,
            cancel: _vm.onCancelRemoveDeliverable
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this deliverable?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-campaign",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialCampaignModal",
            title: "Edit Social Campaign"
          }
        },
        [
          _c("SocialCampaignDialog", {
            ref: "refSocialCampaignDialogModal",
            attrs: { namespace: _vm.namespace },
            on: { socialCampaignClose: _vm.createCampaignClose }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-header" },
        [
          _c("HeaderIcon", {
            attrs: {
              totalDeliverableCount: this.allDeliverablesPaginationData.total
                ? this.allDeliverablesPaginationData.total
                : 0,
              totalOutletCount: this.outletCount ? this.outletCount : 0,
              myWeek: _vm.myWeek
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("SocialTabs"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-block-wrap" },
        [
          _c("div", { staticClass: "group-by-wrap dropdown" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dropdown-menu" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      to: {
                        name: "socialMedia",
                        params: {
                          filterQuery: _vm.deliverableFilter,
                          socialGroupBy: "socialMedia"
                        }
                      }
                    }
                  },
                  [_vm._v("Dates")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      to: {
                        name: "socialMediaGrouped",
                        params: {
                          filterQuery: _vm.deliverableFilter,
                          socialGroupBy: "socialMediaGrouped"
                        }
                      }
                    }
                  },
                  [_vm._v("Campaign/Series")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("HorizontalMonthPicker"),
          _vm._v(" "),
          _c("div", { staticClass: "deliverable-block" }, [
            _c("div", { staticClass: "delv-block-resp" }, [
              _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "dbox-left-side dleft-inner-wrap" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.deliverablesArray, function(deliverable, index) {
                      return index != "totalOutlets"
                        ? _c(
                            "div",
                            {
                              key: "deliverable" + index,
                              staticClass: "row listing-row"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col titles breakpoint__fix",
                                  style: _vm.infoColStyle(deliverable)
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: "deliverable-title edit-d-title",
                                      on: {
                                        click: function($event) {
                                          return _vm.showModalFn(deliverable.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(deliverable.title) +
                                          " \n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mobile-task-expand-button-area"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "mobile-task-exp-btn" },
                                        [
                                          _c("CollapseTaskBtn", {
                                            attrs: {
                                              deliverable: deliverable,
                                              index: index,
                                              expandAll: _vm.expandAll
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.userCanEditDeliverable()
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            },
                                            {
                                              name: "click-outside",
                                              rawName: "v-click-outside",
                                              value: _vm.deleteDeliverableClickOutside(
                                                deliverable.id
                                              ),
                                              expression:
                                                "deleteDeliverableClickOutside(deliverable.id)"
                                            }
                                          ],
                                          class:
                                            "delete-bar " +
                                            (deliverable.id ==
                                            _vm.stripRemoveDeliverableId
                                              ? "hovered"
                                              : ""),
                                          attrs: { title: "Delete" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.deleteDeliverableClick(
                                                deliverable
                                              )
                                            }
                                          }
                                        },
                                        [_vm._m(2, true)]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm._.filter(deliverable.customFields, {
                                  field_key: "user"
                                }),
                                function(field, index) {
                                  return !_vm.isMobile()
                                    ? _c(
                                        "div",
                                        {
                                          key:
                                            "" +
                                            deliverable.id +
                                            field.field_id,
                                          staticClass: "col infos"
                                        },
                                        [
                                          _c("SocialCustomFields", {
                                            attrs: {
                                              customField: field,
                                              deliverable: deliverable
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm._.filter(deliverable.customFields, {
                                  field_key: "post_date"
                                }),
                                function(field, index) {
                                  return !_vm.isMobile()
                                    ? _c(
                                        "div",
                                        {
                                          key:
                                            "" +
                                            deliverable.id +
                                            field.field_id,
                                          staticClass: "col infos"
                                        },
                                        [
                                          _c("SocialCustomFields", {
                                            attrs: {
                                              customField: field,
                                              deliverable: deliverable
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              ),
                              _vm._v(" "),
                              _vm._m(3, true),
                              _vm._v(" "),
                              _vm._m(4, true),
                              _vm._v(" "),
                              _vm._m(5, true),
                              _vm._v(" "),
                              _vm._m(6, true),
                              _vm._v(" "),
                              _vm._l(
                                _vm._.filter(deliverable.customFields, {
                                  field_key: "social_status"
                                }),
                                function(field, index) {
                                  return !_vm.isMobile()
                                    ? _c(
                                        "div",
                                        {
                                          key:
                                            "" +
                                            deliverable.id +
                                            field.field_id,
                                          staticClass: "col infos"
                                        },
                                        [
                                          _c("SocialCustomFields", {
                                            attrs: {
                                              customField: field,
                                              deliverable: deliverable
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "new-social-group-container dropright" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                  on: { click: _vm.createCampaignClick }
                },
                [_vm._v("Campaign")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                  on: { click: _vm.createSeriesClick }
                },
                [_vm._v("Series")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.myWeek,
                  expression: "!myWeek"
                }
              ],
              staticClass: "pagination-wrapper"
            },
            [
              _c("pagination", {
                attrs: {
                  data: _vm.allDeliverablesPaginationData,
                  limit: _vm.isMobile() ? 3 : 5,
                  size: _vm.isMobile() ? "small" : "default"
                },
                on: { "pagination-change-page": _vm.onChangePage }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme header-filter-btns",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("List by "),
        _c("i", {
          staticClass: "fas text-primary float-right fa-chevron-down fa-fw"
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-row social list-labels" }, [
      _c("div", { staticClass: "data-items social-name" }, [
        _c("span", [_vm._v("Post Name")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-people" }, [
        _c("span", [_vm._v("People")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-date" }, [
        _c("span", [_vm._v("Posting Date")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-thumbnail" }, [
        _c("span", [_vm._v("Image")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-caption" }, [
        _c("span", [_vm._v("Post Copy")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-platforms" }, [
        _c("span", [_vm._v("Platforms")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-languages" }, [
        _c("span", [_vm._v("EN/FR")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "data-items social-status" }, [
        _c("span", [_vm._v("Status")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-trash" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col infos" }, [
      _c("span", [_vm._v("Image")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col infos" }, [
      _c("span", [_vm._v("Post Copy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col infos" }, [
      _c("span", [_vm._v("Platforms")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col infos" }, [
      _c("span", [_vm._v("Languages")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme header-filter-btns",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("New "),
        _c("i", { staticClass: "fas text-primary float-right fa-plus fa-fw" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }